import api from './api';
import type { Notification } from '../types/notification';

const BASE_PATH = '/admin/notification';

export const notificationAPI = {
  getList: async (): Promise<Notification[]> => {
    const response = await api.get<Notification[]>(BASE_PATH);
    return response.data;
  },

  markAsRead: async (id: string): Promise<{ message: string }> => {
    const response = await api.patch<{ message: string }>(`${BASE_PATH}/${id}/read`);
    return response.data;
  },

  markAllAsRead: async (): Promise<{ message: string }> => {
    const response = await api.patch<{ message: string }>(`${BASE_PATH}/read`);
    return response.data;
  },
};
